import { AsyncTabChangeHandler } from "../AsyncTabChangeHandler";

/**
 * Raises the tab transition events.
 * @param tabId The ID of the tab being transitioned.
 * @param onBefore The onBefore callback.
 * @param onSelectedTabChange The onSelectedTabChange callback.
 * @param onBusy Signals that the tab is busy.
 * @param onError Signals that the tab has produced an error.
 * @param onDone Signals that tab events have finished firing.
 * @returns True if tab transition should continue, otherwise false.
 */
export async function raiseTransition(
  tabId: string | null,
  onBefore: AsyncTabChangeHandler | undefined,
  onBusy: (tabId: string) => void,
  onError: (tabId: string) => void,
  onDone: (tabId: string) => void,
): Promise<boolean> {
  if (tabId === null) return true;

  try {
    onBusy(tabId);
    await onBefore?.(tabId);
    return true;
  } catch {
    onError(tabId);
    return false;
  } finally {
    onDone(tabId);
  }
}
